import { getPathname } from './getPathname';

export const isCookieAuthentication = () => {
  const pathname = getPathname();
  return pathname.includes('v3/prescription');
};

export const isBasicAuthentication = () => {
  const pathname = getPathname();
  return pathname.includes('v2/prescription');
};
